export default __webpack_public_path__ + "static/media/cart-is-empty.ab3f7f35.svg";